
import styles from "./ProgressBar.module.css";

const ProgressBar = ({
  current=0
}) => {
  return (
    <div className={styles.progressBar}>
      {Array.from(
        { length: 7 },
        (_, i) => <div key={i} className={`${styles.bar} ${ current == i ? styles.selected : "" }`}>  </div>
      )}
    </div>
  );
};

export default ProgressBar;

